import React from 'react';

const IconMedium = () => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="24"
    height="24"
    viewBox="0 0 24 24"
    fill="none"
    stroke="currentColor"
    strokeWidth="2"
    strokeLinecap="round"
    strokeLinejoin="round">
    <g>
      <ellipse cx="5.5" cy="12" rx="4.5" ry="7" fill="currentColor" />
      <ellipse cx="18.5" cy="12" rx="2.5" ry="7" fill="currentColor" />
      <ellipse cx="12" cy="12" rx="2.5" ry="7" fill="currentColor" />
    </g>
  </svg>
);

export default IconMedium;
